export function evaluateCondition (condition, elementValues) {
  if (!condition) return false;
  if (!condition.id) throw new Error(this.$t('frontendErrorCodes.UNEXPECTED'));
  if ((condition.operator === undefined || ['oneOf', 'notOneOf'].includes(condition.operator)) && (!condition.value || !Array.isArray(condition.value))) {
    throw new Error(this.$t('frontendErrorCodes.UNEXPECTED'));
  }
  switch (condition.operator) {
    case undefined:
    case 'oneOf':
      return condition.value.includes(elementValues[condition.id]);
    case 'notOneOf':
      return !condition.value.includes(elementValues[condition.id]);
    case 'empty':
      return !elementValues[condition.id];
    case 'notEmpty':
      return !!elementValues[condition.id];
    default:
      throw new Error(this.$t('frontendErrorCodes.UNEXPECTED'));
  }
}

export const errorFields = (fields) => {
  const ret = [];
  const recurse = (node, parent = '') => {
    if (Array.isArray(node)) {
      for (const item of node) {
        recurse(item, parent);
      }
    } else if (typeof node === 'object') {
      for (const key of Object.keys(node)) {
        recurse(node[key], parent ? parent + '.' + key : key);
      }
    } else {
      ret.push(parent + ': ' + node);
    }
  };
  recurse(fields);
  return '• ' + ret.join('\n• ');
};
